var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg2Filled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "circle-2",
    clipPath: "url(#clip0_1003_1692)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16 0C7.1625 0 0 7.1625 0 16C0 24.8375 7.1625 32 16 32C24.8375 32 32 24.8375 32 16C32 7.1625 24.8375 0 16 0ZM20.5 24H11.5C10.8799 24 10.3244 23.6191 10.1006 23.0387C9.877 22.4606 10.0333 21.8044 10.4923 21.3881L17.2673 15.2437C17.7077 14.8101 17.9741 14.1813 17.9741 13.515C17.9741 12.8488 17.7075 12.22 17.2241 11.7456C16.2125 10.75 14.5563 10.75 13.5375 11.7437L12.85 12.4187C12.2563 13.0062 11.2562 12.9937 10.7312 12.4C10.15 11.8062 10.1562 10.8562 10.75 10.2812L11.4375 9.6075C13.6125 7.47062 17.1531 7.47062 19.3312 9.6075C20.3937 10.6506 20.98 12.0394 20.98 13.5175C20.98 14.9956 20.3941 16.385 19.3312 17.4275L15.3875 21H20.5C21.3281 21 22 21.6719 22 22.5C22 23.3281 21.3312 24 20.5 24Z",
    fill: "#757575"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1003_1692"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2Filled);
export default __webpack_public_path__ + "static/media/2filled.c0b36550b0d3f1834694b53b27f4baf5.svg";
export { ForwardRef as ReactComponent };